import { useState } from "react";

const C = {
  cream: "#F5F1EA",
  white: "#FFFFFF",
  dark: "#163C2F",
  muted: "#9B9690",
  border: "#D4CFC7",
  red: "#dc2626",
  redPale: "#FEF2F2",
  amber: "#B08D57",
  amberPale: "#FEF9EE",
};

export default function PaymentFailed({ supabase }) {
  const params = new URLSearchParams(window.location.search);
  const paymentId = params.get("payment_id") || "";
  const isCancelled = params.get("cancelled") === "true";
  const [retrying, setRetrying] = useState(false);
  const [error, setError] = useState(null);

  const handleRetry = async () => {
    if (!paymentId) return;
    setRetrying(true);
    setError(null);
    try {
      const { data, error: fnErr } = await supabase.functions.invoke("create-rent-checkout", {
        body: { payment_id: Number(paymentId) },
      });
      const errMsg = data?.error || fnErr?.message;
      if (errMsg || !data?.url) {
        setError(errMsg === "CONNECT_NOT_READY"
          ? "Online payment is not set up for this property yet. Please contact your landlord."
          : errMsg || "Something went wrong. Please try again.");
        setRetrying(false);
        return;
      }
      window.location.href = data.url;
    } catch (err) {
      setError(String(err));
      setRetrying(false);
    }
  };

  const iconColor = isCancelled ? C.amber : C.red;
  const iconBg    = isCancelled ? C.amberPale : C.redPale;

  return (
    <div style={{ minHeight: "100vh", background: C.cream, fontFamily: "'Manrope', 'Outfit', sans-serif", padding: "0 16px" }}>
      <div style={{ maxWidth: 480, margin: "0 auto", paddingTop: 80, paddingBottom: 64, textAlign: "center" }}>
        {/* Icon */}
        <div style={{
          width: 80, height: 80, borderRadius: "50%",
          background: iconBg, border: `3px solid ${iconColor}44`,
          display: "inline-flex", alignItems: "center", justifyContent: "center",
        }}>
          {isCancelled ? (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          ) : (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          )}
        </div>

        <h1 style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: 36, color: C.dark, marginTop: 28, marginBottom: 10, lineHeight: 1.1,
        }}>{isCancelled ? "Payment Cancelled" : "Payment Failed"}</h1>

        <p style={{ fontSize: 15, color: C.muted, lineHeight: 1.7, margin: "0 auto 36px", maxWidth: 380 }}>
          {isCancelled
            ? "No worries! Your payment was not processed. You can try again whenever you're ready."
            : "Your payment could not be processed. Please check your card details and try again."}
        </p>

        {error && (
          <div style={{
            background: C.redPale, border: `1px solid ${C.red}33`, borderRadius: 10,
            padding: "12px 16px", marginBottom: 24, fontSize: 13, color: C.red, lineHeight: 1.5,
          }}>
            {error}
          </div>
        )}

        {/* Buttons */}
        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
          {paymentId && (
            <button onClick={handleRetry} disabled={retrying} style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: C.dark, color: C.cream, border: "none", borderRadius: 999,
              padding: "13px 28px", fontWeight: 700, fontSize: 13, cursor: "pointer",
              fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em",
              opacity: retrying ? 0.6 : 1,
            }}>
              {retrying ? "Loading…" : "Try Again"}
            </button>
          )}
          <a href="/tenant" style={{
            display: "inline-flex", alignItems: "center", gap: 8, textDecoration: "none",
            background: C.white, color: C.dark, border: `1.5px solid ${C.dark}`,
            borderRadius: 999, padding: "13px 28px", fontWeight: 700, fontSize: 13,
            fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em",
          }}>
            Back to Portal
          </a>
        </div>

        {/* Footer */}
        <p style={{ fontSize: 11, color: C.muted, marginTop: 48, opacity: 0.7 }}>
          Gibbs Prodigy Group &middot; Powered by Leasly
        </p>
      </div>
    </div>
  );
}
